module.exports = __webpack_public_path__ + "img/6.c2fc6e70.png";